export class Select2Ajax {
    constructor() {
        this.selectLists = document.querySelectorAll('.select2-ajax');

        this.selectLists.forEach(selectList => {
            this.initSelect2(selectList);
        });
    }

    initSelect2(selectList) {
        $(selectList).select2({
            ajax: {
                url: selectList.dataset.url,
                type: 'get',
                data: function (params) {
                    let query = {
                        search: params.term
                    }

                    return query;
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                }
            }
        });
    }
}
